export default [
  {
    // 404 → no matching resource
    path: '404/:resource',
    name: '404-resource',
    // preventing from accesing this page without login
    meta: { requireAuth: true },
    props: true,
    component: () => import(/* webpackChunkName: "not-found-resource" */ 'Pages/NotFound'),
  },

  {
    // 404 → no matching page
    path: 'not-found',
    alias: '/:catchAll(.*)',
    name: '404',
    meta: { requireAuth: true },
    component: () => import(/* webpackChunkName: "not-found" */ 'Pages/NotFound'),
  },
]
